<template>
    <div id="inputOtherMediaCostContainer">
        <div class="header">
            <h3>自社広告費手動入力</h3>
            <a class="btn close" @click="$emit('modalClosed')"></a>
        </div>
        <div class="main">
            <span class="media">広告媒体：</span>
            <v-select name="hoge" class="select" :options="options" v-model="submitData.medium"></v-select>
            <span class="product">商品：【{{ productDatas.productId }}】{{ productDatas.productName }}</span>
            <div class="costs">
                <div v-for="(services, privateSite) in submitData.services" :key="privateSite">
                    <div>
                        <div class="service">{{ privateSite }}</div>
                        <div v-for="(service, index) in services" :key="index">
                            <div class="cost">
                                <span class="outputday">{{ service.outputday }}</span>
                                <input type="number" :value="service.cost ? service.cost : ''"
                                    @input="inputCost($event, privateSite, index)">
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <a @click="updateCosts" class="btn">更新</a>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            submitData: {
                productId: '',
                medium: '',
                services: {}
            },
            options: [],
            dates: []
        }
    },
    props: {
        productDatas: Object
    },
    created: function () {
        this.dates = Object.keys(this.productDatas.outputs);
        // 手入力媒体の配列作成のためインデックスは0を指定
        this.options = Object.keys(this.productDatas['outputs'][this.dates[0]]['costsOfMedia']['privateSite']['otherMediaDetail']);
        this.submitData.productId = this.productDatas.productId;
    },
    watch: {
        'submitData.medium': function () {
            this.$set(this.submitData.services, 'amepla', []);
            this.$set(this.submitData.services, 'ametore', []);
            this.$set(this.submitData.services, 'nelture', []);
            this.$set(this.submitData.services, 'natumee', []);
            this.dates.forEach(outputday =>
                Object.keys(this.productDatas['outputs'][outputday]['costsOfMedia']['privateSite']['otherMediaDetail'][this.submitData.medium]).forEach(privateSite => {
                    if (privateSite === 'totalPrivateSiteCosts') { return; }
                    // 日付で降順
                    this.submitData.services[privateSite].unshift({
                        'outputday': outputday,
                        'cost': this.productDatas['outputs'][outputday]['costsOfMedia']['privateSite']['otherMediaDetail'][this.submitData.medium][privateSite]
                    })
                })
            );
        }
    },
    methods: {
        inputCost(event, privateSite, index) {
            this.submitData['services'][privateSite][index]['cost'] = event.target.value;
        },
        updateCosts() {
            // this.$store.dispatch("loading", true)
            this.axios.put("api/otherCosts", this.submitData)
                .then(() => {
                    this.$emit('modalClosed');
                    this.$emit('postInputMediaCosts');

                    // this.axios.get("/api/linkedProductAndAds")
                    // .then((res) => {
                    //     this.products = res.data
                    //     this.$emit("updateProducts", this.products)
                    //     this.modalShow = false
                    //     this.$modal.hide("EditProduct")
                    // }).catch(() => {
                    // })

                }).catch(() => {
                })
        }
    }
}
</script>

<style scoped lang="sass">
#inputOtherMediaCostContainer
    padding: 16px 32px
    height: 100%
    width: 100%
    color: $grayColor
    overflow-y: scroll
    .header
        padding: 5px
        height: 50px
        margin-bottom: 10px
        h3
            display: block
            float: left
            font-size: 20px
        .btn.close
            float: right
    .main
        .media
            display: inline-block
            font-size: 16px
        .select
            display: inline-block
            width: 250px
            font-size: 14px
        .product
            display: inline-block
            font-size: 16px
            margin-left: 60px
        .costs
            border: 1px solid $mainColor
            padding: 24px 48px
            margin: 16px 0px 32px 0px
            min-height: 200px
            height: 50vh
            overflow: scroll
            display: flex
            justify-content: space-between
            .service
                font-size: 16px
                margin-bottom: 8px
                font-weight: bold
            .cost
                margin-bottom: 4px
                .outputday
                    margin-right: 8px
                    font-size: 16px
        .btn
            display: block
            margin: 0 auto
            border: 1px solid $mainColor
            padding: 10px
            width: 100px
            &:hover
                border: 1px solid $mainColor
</style>
